<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md6 lg5 xl4>

            <template>
              <v-card class="elevation-1">
                <v-toolbar dark color="light-blue darken-3" class="elevation-0">
                  <v-toolbar-title>Восстановление пароля</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-toolbar-title>[edoc].cloud</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                  <v-form ref="reg_start" lazy-validation>
                    <v-text-field
                            v-model="phone"
                            :error-messages="phoneErrors"
                            prepend-icon="phone"
                            mask="## (###) ###-##-##"
                            label="Номер телефона"
                            type="text"
                            @input="$v.phone.$touch()"
                            @blur="$v.phone.$touch()"></v-text-field>
                    <v-text-field
                            v-if="step === 1"
                            v-model="code"
                            :error-messages="codeErrors"
                            prepend-icon="sms"
                            mask="####"
                            label="Смс код"
                            type="text"
                            @input="$v.code.$touch()"
                            @blur="$v.code.$touch()"></v-text-field>
                    <v-text-field
                            v-if="step === 1"
                            v-model="password"
                            :error-messages="passwordErrors"
                            prepend-icon="lock"
                            label="Новый пароль"
                            type="password"
                            @input="$v.password.$touch()"
                            @blur="$v.password.$touch()"></v-text-field>
                    <v-text-field
                            v-if="step === 1"
                            v-model="password2"
                            :error-messages="password2Errors"
                            prepend-icon="lock"
                            label="Подтверждение нового пароля"
                            type="password"
                            @input="$v.password2.$touch()"
                            @blur="$v.password2.$touch()"></v-text-field>
                  </v-form>
                  <v-alert :value="done" type="success">
                    Пароль успешно изменен. <router-link class="white--text" :to="{name:'auth'}">Авторизироваться</router-link>
                  </v-alert>
                </v-card-text>
                <v-card-actions v-if="step === 0">
                  <v-spacer></v-spacer>
                  <v-btn dark color="light-blue darken-3" @click="submit()">Получить смс-код</v-btn>
                </v-card-actions>
                <v-card-actions v-if="step === 1">
                  <v-spacer></v-spacer>
                  <v-btn dark color="light-blue darken-3" @click="submit()">Изменить пароль</v-btn>
                </v-card-actions>
              </v-card>
              <v-card class="elevation-1 mt-3">
                <v-card-text>
                  Уже есть аккаунт? <router-link :to="{name:'auth'}">Авторизироваться</router-link>
                </v-card-text>
              </v-card>
            </template>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, sameAs, minLength, helpers } from 'vuelidate/lib/validators'

  const phoneFormat = helpers.regex('phone', /^380[0-9]{9}$/g)

  export default {
    mixins: [validationMixin],

    validations () {
      if (this.step === 0) {
        return {
          phone: { required, phoneFormat }
        }
      }
      return {
        phone: { required, phoneFormat },
        code: { required },
        password: { required, minLength: minLength(6) },
        password2: { required, minLength: minLength(6), sameAsPassword: sameAs('password') }
      }
    },

    data () {
      return {
        step: 0,
        phone: '',
        code: '',
        password: '',
        password2: '',
        done: false,
        errors: []
      }
    },
    methods: {
      submit () {

        this.errors = []

        this.$v.$touch()
        if (this.$v.$invalid)
          return

        if (this.step === 0)
          this.$store.dispatch('userSendRecoverSms', {
            phone: this.phone
          }).then(() => {
            this.step = 1
          }).catch(error => {
            this.errors = error.response.data.errors
          })
        else
          this.$store.dispatch('userChangePassword', {
            phone: this.phone,
            code: this.code,
            password: this.password
          })
          .then(() => { 
            this.done = true 
          })
          .catch(error => {
            this.errors = error.response.data.errors
          })
      }
    },
    computed: {
      phoneErrors () {
        let errors = []
        if (!this.$v.phone.$dirty) return errors
        !this.$v.phone.required && errors.push('Обязательное поле.')
        !this.$v.phone.phoneFormat && errors.push('Неверный формат номера телефона. Пример: 38 (0##) ###-##-##')
        return errors.concat(this.errors.filter(i => i.field === 'phone').map(i => i.message))
      },
      codeErrors () {
        let errors = []
        if (!this.$v.code.$dirty) return errors
        !this.$v.code.required && errors.push('Обязательное поле.')
        return errors.concat(this.errors.filter(i => i.field === 'code').map(i => i.message))
      },
      passwordErrors () {
        let errors = []
        if (!this.$v.password.$dirty) return errors
        !this.$v.password.required && errors.push('Обязательное поле.')
        !this.$v.password.minLength && errors.push('Минимальная длина пароля 6 символов.')
        return errors.concat(this.errors.filter(i => i.field === 'password').map(i => i.message))
      },
      password2Errors () {
        let errors = []
        if (!this.$v.password2.$dirty) return errors
        !this.$v.password2.required && errors.push('Обязательное поле.')
        !this.$v.password2.minLength && errors.push('Минимальная длина пароля 6 символов.')
        !this.$v.password2.sameAsPassword && errors.push('Пароли не совпадают.')
        return errors.concat(this.errors.filter(i => i.field === 'password2').map(i => i.message))
      }
    }
  };
</script>